import React, {Component} from 'react';
import Button from "../Button/Button";
import {DownloadOutlined} from '@ant-design/icons';

import './styles.scss'

interface ExportProps {
    fetchData: any,
    onClick: any,
    callback: any,
    fileName: string,
    loading?: boolean,
    buttonText?: string
}

export default class Export extends Component<ExportProps, any> {
    onButtonClick = async (e:React.MouseEvent<HTMLButtonElement>) => {
        const { loading, fetchData, fileName, callback, onClick } = this.props;
        if (loading) return null;

        onClick();

        const csvData = await fetchData();
        var csvFile = new Blob([csvData.join('\n')], {type: 'text/csv;charset=utf-8;'});

        const link = document.createElement("a");
        const url = URL.createObjectURL(csvFile);
        link.setAttribute("href", url);
        link.setAttribute("download", `${fileName}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        callback();
    };

    render(){
        const { buttonText, loading } = this.props;

        return(
            <Button onClick={this.onButtonClick} icon={<DownloadOutlined/>} iconPosition='left' loading={loading}>
                {buttonText ? buttonText : 'Export'}
            </Button>
        )
    }
}